module.exports = __webpack_public_path__ + "static/contactShrimp.c5eef2f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contactShrimp.png
// module id = 224
// module chunks = 35783957827783 278999228825771